export default "__VITE_ASSET__Btc6H_1J__"